module.exports = __webpack_public_path__ + "img/select-train.527d8fe7.png";